module.exports = __webpack_public_path__ + "static/media/beef-guarantee.ba86b4dd.jpg";